<template>
  <section class="form">
    <card-component title="Archive Learners" icon="ballot">
      <div>
        <p>Upload file with learners emails.</p>
        <p>
          The maximum number of learners per file shouldn't exceed
          <span class="has-text-weight-bold">100</span>
        </p>
      </div>
      <br />
      <b-field class="file" :class="{ 'is-success': form.projectId, 'has-name': !!file }">
        <b-upload v-model="file" class="file-label" @change="onChange">
          <span class="file-cta">
            <b-icon class="file-icon" icon="upload"></b-icon>
            <span class="file-label">Upload Spreadsheet</span>
          </span>
          <span class="file-name" v-if="file">
            {{ file.name }}
          </span>
        </b-upload>
      </b-field>
      <xlsx-read :file="file">
        <xlsx-json :sheet="0">
          <template #default="{ collection }">
            <b-loading style="z-index: 100;" :is-full-page="true" :active="file && !collection" :can-cancel="false">
              <div class="loading-container">
                <div class="loading">
                  <p>loading</p>
                  <span></span>
                </div>
              </div>
            </b-loading>
            <div v-if="collection && file">
              <hr />
              <b-table v-if="collection" :bordered="true" :striped="true" :narrowed="true" :data="collection"
                :columns="columns">
              </b-table>
              <hr />
              <div>
                Please ensure you double checked:
              </div>
              <span>
                <ul>
                  <li>- All email addresses are properly formatted.</li>
                </ul>
              </span>
              <hr />
              <div>
                If you have spotted an error press Reset and re-upload the
                corrected sheet.
              </div>
              <div>
                Otherwise if you are happy, press Submit!
              </div>
              <hr />

              <b-message v-if="submitMessage" title="Submission Results"
                :type="submitMessage.submitted ? 'is-info' : 'is-danger'">
                <span v-for="text in submitMessage.message.split('$$')" :key="text">
                  <div v-if="checkText(text)" style="color:#FFA500">
                    {{ text.replace(",", " ") }}
                  </div>
                  <div v-else>
                    {{ text.replace(",", " ") }}
                  </div>
                  <br />
                </span>
              </b-message>
              <b-field grouped>
                <div class="control">
                  <b-button type="is-primary is-success is-outlined" @click="reset()" v-html="'Reset'" />
                </div>
                <div class="control">
                  <b-button type="is-primary is-success" @click="submit(collection)" v-html="'Submit'" />
                </div>
              </b-field>
            </div>
          </template>
        </xlsx-json>
      </xlsx-read>
    </card-component>
  </section>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import mapValues from "lodash/mapValues";
import { XlsxRead, XlsxJson } from "vue-xlsx";
import { mapState, mapActions } from "vuex";

export default {
  name: "UploadLearnerComponent",
  components: {
    CardComponent,
    XlsxRead,
    XlsxJson
  },
  data() {
    return {
      isLoading: false,
      form: {
        content: null
      },
      file: null,
      collection: null,
      submission: null,
      submitMessage: null,
      errorMessage: "Couldn't process file",
      columns: [
        {
          field: "email",
          label: "Email",
          width: "60"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      user: "user",
      projects: state => state.globalStore.projects
    })
  },
  methods: {
    ...mapActions({
      archiveLearnsFileUpload: "globalStore/archiveLearnsFileUpload",
      loading: "SET_SCREEN_LOADING"
    }),
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    async submit(collection) {
      this.loading(true);
      this.form.content = collection;

      const learners = collection.map(user => {
        const userData = {
          email: user.email
        };

        return userData;
      });

      this.submitMessage = await this.archiveLearnsFileUpload(learners);

      this.loading(false);
    },
    reset() {
      this.file = null;
      this.submitMessage = null;
      this.collection = null;
      this.form = mapValues(this.form, item => {
        if (item && typeof item === "object") {
          return [];
        }
        return null;
      });
    },
    checkText(val) {
      return val.includes(this.errorMessage);
    }
  }
};
</script>
